import { CallLogFileHandler, CallLogParseResult } from '../../models/callLogFileHandler';
import { parse, ParseResult } from 'papaparse';
import { getCallLogFileId } from '../../store/actions/createJobActions';

export const csvCallLogFileHandler: CallLogFileHandler = {
	canParse: (extension, mime) => {
		return extension === 'csv' || mime === 'text/csv';
	},
	parse: (file) => {
		return new Promise<CallLogParseResult>((resolve) => {
			parse<string[]>(file, {
				header: false,
				skipEmptyLines: true,
				complete: (results: ParseResult<string[]>) => {
					const rows = results.data ?? [];
					if (rows.length && rows[0].length) {
						resolve({
							type: 'success',
							file: {
								type: 'csv',
								id: getCallLogFileId(),
								filename: file.name,
								data: {
									rows
								}
							}
						});
					} else {
						resolve({type: 'error', error: { type: 'empty' }});
					}
				},
				error: (error) => {
					resolve({type: 'error', error: { type: 'parseFailed' }});
				}
			})
		});	
	}
}